export const storefrontClient = async (query: string, variables: any) => {
  const responce = await fetch(import.meta.env.SHOPIFY_STOREFRONT_API_URL,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': import.meta.env.SHOPIFY_STOREFRONT_API_KEY
      },
      body: JSON.stringify({
        query,
        variables
      })
    }
  )
  const data = await responce.json();
  return data;
}
